<template>
  <router-view />
  <BottomNav />
  <SettingsModal />
  <ChangePasswordModal />
  <TwoFactorModal />
</template>

<script>
import BottomNav from "@/components/work-sched/bottom-nav.vue";
import SettingsModal from "@/components/work-sched/settings-modal.vue";
import ChangePasswordModal from "@/components/work-sched/change-password-modal.vue";
import TwoFactorModal from "@/components/work-sched/two-factor-modal.vue";
import { authComputed } from "@/state/helpers";
import {
  startSessionTimeout,
  resetSessionTimeout,
  clearSessionTimeout,
} from "@/services/session-timeout";

export default {
  name: "App",
  components: {
    BottomNav,
    SettingsModal,
    ChangePasswordModal,
    TwoFactorModal,
  },
  computed: {
    ...authComputed,
  },
  watch: {
    loggedIn(v) {
      // Fresh login starts the clock; logout drops the stamp.
      if (v) resetSessionTimeout();
      else clearSessionTimeout();
    },
  },
  mounted() {
    startSessionTimeout();
    // Refresh cached identity/permission flags on load so newly-tagged
    // "requires 2FA" permissions take effect without forcing a re-login.
    if (this.loggedIn) {
      this.$store.dispatch("auth/refreshProfile").catch(() => {});
    }
  },
};
</script>
